import React from 'react'

const getDevelopmentPanel = (big = false) => {
	const className = big ? 'inDevelopTitle' : ''
	return (
		<div className={ className }>En développement</div>
	)
}


export { getDevelopmentPanel }



// WEBPACK FOOTER //
// ./src/utils/DevelopmentUtil.js